module.exports = __webpack_public_path__ + "img/1-2.df895d0c.webp";